import './thanks.css';

export default function Thanks() {
  return (
    <>
    <div className='thanks'>
        <div className='thankstitle'>
        <div className='thankslg'> Thanks you ...!! </div>
        <div className='thankssm'>We will get back to you soon</div>
        </div>
        </div>
        </>
  )
}
